import { ModeEdit, Send } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import HttpServices from 'src/services/httpService';
import { imageModeuleUrl, postsModuleURL, userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ScheduledPostActionPopup from './PostGridActionPopup.component';

const ScheduledPostGridAction = ({ scheduledPost, handleReCallScheduledPost, isOrgEvent }) => {
  const { t: translate } = useTranslation();

  const { showToast } = useToaster();
  const [selectedPopOverPost, setPopOverPost] = useState(null);
  const [popoverElement, setPopoverElement] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogue, setConfirmationDialogue] = useState(null);
  const navigate = useNavigate();

  const handleOpenMenu = (event, scheduledPost) => {
    setPopOverPost(scheduledPost);
    setPopoverElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setPopOverPost(null);
    setPopoverElement(null);
  };

  const closeConfirmationDialogue = () => {
    setConfirmationDialogue(null);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    handleCloseMenu();
    closeConfirmationDialogue();
    setLoading(false);
  };

  const postNowSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallScheduledPost();
  };

  const handlePostNow = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: translate('scheduled_post.confirm_post_now'),
      message: translate('scheduled_post.want_to_post_schedule'),
      submitFunction: confirmPostNow,
    });
  };

  const confirmPostNow = (post) => {
    let postNowProps = {
      schedule_id: scheduledPost.id,
      new_post_time: new Date().toISOString(),
    };
    let postProps = {
      url: postsModuleURL.reScheduleNewPost,
      body: postNowProps,
      successCallback: postNowSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const fetchMediaMetaData = (data, editAsNew = false) => {
    let mediaBody = {
      media_urls: data?.media_url.split(','),
    };
    let postProps = {
      url: imageModeuleUrl.fetchMediaMetadata,
      body: mediaBody,
      successCallback: (imageData, message) => {
        fetchMediaSuccessCallback(imageData, message, data, editAsNew);
      },
      failureCallback: failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const fetchMediaSuccessCallback = (imageData, mesaage, data, editAsNew) => {
    if (editAsNew) {
      uploadEditDataToNewPost(data, imageData ? imageData.media_datas : []);
    } else {
      uploadDataToPost(data, imageData ? imageData.media_datas : []);
    }
  };
  const newPostSucessCallback = (data) => {
    if (data.media_url && data.media_url.length > 0) fetchMediaMetaData(data);
    else uploadDataToPost(data);
  };

  const editNewPostSucessCallback = (data) => {
    let editAsNew = true;
    if (data.media_url && data.media_url.length > 0) fetchMediaMetaData(data, editAsNew);
    else uploadEditDataToNewPost(data);
  };

  const uploadDataToPost = (data, imageData = []) => {
    setLoading(false);
    const updatedData = {
      ...data,
      media_data: imageData,
      schedule_id: scheduledPost?.id,
    };
    const newPostData = CommonHelper.CommonNewPostAddMediaAllService(updatedData, imageData);
    navigate('/new-post', { state: { data: newPostData } });
  };
  const uploadEditDataToNewPost = (data, imageData = []) => {
    setLoading(false);
    const newPostData = CommonHelper.CommonNewPostAddMediaAllService(data, imageData);
    navigate('/new-post', { state: { data: newPostData } });
  };
  const handleEditPost = () => {
    setLoading(true);
    CommonHelper.CommonNewPostStruct(isOrgEvent, scheduledPost.id, newPostSucessCallback, failureCallback);
  };
  const handleEditAsNewPost = () => {
    setLoading(true);
    CommonHelper.CommonNewPostStruct(isOrgEvent, scheduledPost.id, editNewPostSucessCallback, failureCallback);
  };
  const handleSaveAsDraft = () => {
    let props = {
      schedule_post_id: scheduledPost.id,
    };
    let postProps = {
      url: isOrgEvent ? postsModuleURL.orgSavePostAsDraft : postsModuleURL.savePostAsDraft,
      body: props,
      successCallback: saveAsDraftSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const saveAsDraftSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
  };

  const handleDeletePost = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: translate('common.confirm_deletion'),
      message: translate('scheduled_post.delete_this_schedule'),
      submitFunction: confirmDeletePost,
    });
  };

  const confirmDeletePost = () => {
    let postProps = {
      url: isOrgEvent ? postsModuleURL.deleteOrgSchedule + scheduledPost.id : postsModuleURL.deleteSchedule + scheduledPost.id,
      successCallback: deleteSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
    closeConfirmationDialogue();
  };

  const deleteSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallScheduledPost();
  };

  const handleUnapprovePost = () => {
    let unapproveProps = {
      schedule_id: scheduledPost.id,
    };
    let postProps = {
      url: isOrgEvent ? userModuleURL.orgUnApprovePost : userModuleURL.unApprovePost,
      body: unapproveProps,
      successCallback: unapproveSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const unapproveSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallScheduledPost();
  };

  const postActionProps = {
    popoverElement: popoverElement,
    handleCloseMenu,
    handleSaveAsDraft,
    handleEditAsNewPost,
    handleDeletePost,
    handleUnapprovePost,
    loading,
    hasEditAccess: scheduledPost.has_edit_access,
    hasApproveAccess: scheduledPost.has_approve_access,
    selectedPopOverPost: selectedPopOverPost,
  };

  return (
    <>
      <Box display="flex" alignItems="right">
        {scheduledPost.has_edit_access && (
          <Tooltip title="Send Now">
            <IconButton
              size="large"
              color="inherit"
              sx={{ padding: '2px', marginRight: '2px' }}
              onClick={(e) => {
                handlePostNow(e, scheduledPost);
              }}
            >
              <Send />
            </IconButton>
          </Tooltip>
        )}
        {scheduledPost.has_edit_access && (
          <Tooltip title="Edit Post">
            <IconButton
              size="large"
              color="inherit"
              sx={{ padding: '2px', marginRight: '2px' }}
              onClick={(e) => {
                handleEditPost(e, scheduledPost);
              }}
            >
              <ModeEdit />
            </IconButton>
          </Tooltip>
        )}
        <IconButton
          size="large"
          color="inherit"
          onClick={(e) => {
            handleOpenMenu(e, scheduledPost);
          }}
          sx={{ padding: '6px', marginRight: '2px' }}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
      <ScheduledPostActionPopup {...postActionProps} />
      {confirmationDialogue && (
        <ConfirmationDialog
          open={confirmationDialogue.isOpen}
          onClose={() => closeConfirmationDialogue()}
          onConfirm={confirmationDialogue.submitFunction}
          title={confirmationDialogue.title}
          message={confirmationDialogue.message}
        />
      )}
    </>
  );
};

export default ScheduledPostGridAction;
